<template>
  <div class="orderSuccess">

    <img class="successLogo" src="@/assets/animation_200.gif" />

    <h1 class="titleBig tc-success">Payment Successfull!</h1>
<!-- <div class="">
       service id: <span v-html="confirmation.appointment"></span>
      </div> -->
    <div class="orderSuccess__page" v-if="confirmation">
      <div class="orderSuccess__pageInner">
        <h3>Thank you for choosing myPAbox to support you on your journey to becoming a physician assistant. Keep an eye out for an additional email with further instructions regarding your purchase. We look forward to working with you.  </h3>
      </div>
      <div class="seperateLine"></div>

      <div class="orderSuccess__pageInner">
        <h2 class="mb-6">Here's what you ordered:</h2>
        <table class="orderSuccess__table">
          <tr>
            <td class="text-left py-2"><strong> Order no:</strong> {{ confirmation.id }} </td>
            <td v-if="confirmation.appointment" class="text-right py-2"><strong> Date:</strong> <span v-html="moment(confirmation.appointment.createdAt).format('MM/DD/YYYY')"></span> </td>
          </tr>
        </table>
        <table class="orderSuccess__table orderSuccess__table--top">
          <thead>
            <tr>
              <th class="text-left pt-4 tc-white">Item</th>
              <th class="text-right pt-4 tc-white">Cost</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="orderProduct in orderProducts" :key="orderProduct.externalId">
              <td class="text-left py-2">
                <span v-html="orderProduct.nickname ? orderProduct.nickname : orderProduct.product.name"></span>
              </td>
              <td class="text-right py-2">
                <span>{{ formatMoney(orderProduct.unitAmount) }}</span>
              </td>
            </tr>
            <tr>
              <td class="text-left py-2"><strong>Total</strong></td>
              <td class="text-right py-2"><strong>{{ formatMoney(confirmation.checkout.amount_total) }}</strong></td>
            </tr>
          </tbody>
        </table>
      </div>



      <div class="orderSuccess__pageInner" v-if="confirmation.appointment">
        Your booking will be:
        <h3><span v-html="confirmation.appointment.booking.service.title"></span>
        -
        <span v-html="moment(confirmation.appointment.bookedTo).format('MM/DD/YYYY h:MM a')"></span></h3>
      </div>

      <!-- <div class="seperateLine"></div> -->

      <div class="orderSuccess__pageInner">

      </div>

    </div>
    <!-- <div class="orderSuccess__animationCover">
      </div>
    <h1 class="titleBig tc-success">Payment Successfull!</h1>
    <h2>Thank you! Your payment of 200<sup>$ </sup> been recieved</h2>
    <h3>Order ID: xxxx - Transaction ID: xxxx  </h3>

    <div class="">
      <h4>Appointment Details</h4>
      <div class="">
       service id: <span v-html="confirmation.appointment.serviceID"></span>
      </div>
      <div class="">
       createdAt : <span v-html="confirmation.appointment.createdAt"></span>
      </div>
      <div class="">
       bookedTo : <span v-html="new Date(confirmation.appointment.bookedTo)"></span>
      </div>
      <div class="">
       booked title : <span v-html="confirmation.appointment.booking.service.title"></span>
      </div>
      <div class="">
       checkout : <span v-html="confirmation.checkout.amount_total"></span>

      </div>
    </div> -->
    <!-- http://localhost:8080/payments/success?order_id=IqfhkBYsmEO6xrx4TOvn -->
    <!-- <div v-html="confirmation"></div> -->

  </div>
</template>
<script>
import Vue from 'vue'
import moment from 'moment'
import ServiceAPI from '@/lib/serviceApi'
import { formatPrice } from '@/lib/utils'
import ServiceItemMixin from './service-item-mixins'

export default {
  data() {
    return {
      confirmation: null,
    }
  },
  mixins: [ServiceItemMixin],
  components: {},
  methods: {
    formatPrice,
    moment
  },
  computed: {
    changeAmount (total) {
      return formatPrice(total)
    },
    orderProducts () {
      if (!this.confirmation) return []
      return this.confirmation.lineItems.map((item) => {
        return this.allProducts.find(product => product.externalId === item.price)
      }).filter(v => v)
    }
  },
  async created () {
    const order = this.$route.query.order_id
    const confirm = await ServiceAPI.post(`orders/${order}/confirm`)
    this.confirmation  = confirm.data
    this.fetchAllProducts()
    console.log(this)
  }
}
</script>
<style scoped>
.orderSuccess {
  padding-top: 100px;
}
.orderSuccess__page {
  text-align: center;
  background-color: #19143f;
  color: white;
  border-radius: 20px;
  padding: 32px 0;
  max-width: 700px;
  margin: 0 auto;
  box-shadow: 0 8px 30px -14px rgba(0, 0, 0, 0.301);
}

.orderSuccess__pageInner {
  padding: 0 32px;
}

.orderSuccess__animationCover {
  width: 200px;
  height: 200px;
  margin: 0 auto
}
.tc-success {
  color: #4BB543;
}
.tc-white {
  color: #fff;
}

.tc-grey-30 {
  color: hsl(0deg 0% 30%);
}

.titleBig {
  font-size: 32px;
  text-align: center;
  margin: 40px 0 40px;
}
@media (min-width: 960px) {
  .titleBig {
    font-size: 48px;
  }
}

.orderSuccess__table--top {
  border-top: 1px solid hsl(0deg 0% 30%);
}

.orderSuccess__table,
.orderSuccess__table thead {
  width: 100%;
}

.orderSuccess__table th {
  font-weight: normal;
}
.orderSuccess__table td {
  width: 50%;
}

.seperateLine {
  background-color: white;
  width: 100%;
  height: 2px;
  margin: 40px 0;
}

.linkSmall {
  font-size: 10px;
}
.successLogo {
  margin: 40px auto 0;
  max-width: 150px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/Services/ServicesPurchaseSuccess.vue